import type { ReactElement } from "react";
import { StyledFiltersWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import type { TechnologySignalFilterViewProps } from "app/pages/sales-intelligence/sub-modules/signals/components/views/TechnologySignalFiltersView/models/TechnologySignalFilterViewProps";

const TechnologySignalDefaultFiltersView = ({ children }: TechnologySignalFilterViewProps): ReactElement => {
    return (
        <StyledFiltersWrapper
            alignItems="center"
            gap="16px"
        >
            {children}
        </StyledFiltersWrapper>
    );
}

export default TechnologySignalDefaultFiltersView;
